const FooterComponent = () => (
    <footer className="p-6 text-center text-xs text-fin-slate/40 tracking-widest uppercase font-semibold">
        Powered by AAmaze Aggregator
    </footer>
);

export default FooterComponent;
